import React, { useEffect, useState } from "react";
import { Document, Font, Page, StyleSheet, usePDF } from "@react-pdf/renderer";
import RaiseInvoicePdfHeaderView from "../RaiseInvoicePdfHeaderView";
import RaiseInvoicePdfMainContentView from "../RaiseInvoicePdfMainContentView";
import RaiseInvoicePdfFooterView from "../RaiseInvoicePdfFooterView";
import {
  convertToBooleanHelper,
  getReceiptFooterData,
  getReceiptHeaderData,
} from "../helper";

Font.register({
  family: "notosans",
  fonts: [
    {
      src: "https://fonts.gstatic.com/s/notosans/v36/o-0kIpQlx3QUlC5A4PNr4C5OaxRsfNNlKbCePevHtVtX57DGjDU1QDce6Vc.ttf",
      fontWeight: "normal",
      fontStyle: "italic",
    },
    {
      src: "https://fonts.gstatic.com/s/notosans/v35/o-0mIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjcz6L1SoM-jCpoiyD9A99d.ttf",
      fontWeight: "normal",
    }, // font-style: normal, font-weight: normal
    {
      src: "https://fonts.gstatic.com/s/notosans/v36/o-0mIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjcz6L1SoM-jCpoiyDPA99d.ttf",
      fontWeight: "500",
    },
    {
      src: "https://fonts.gstatic.com/s/notosans/v36/o-0mIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjcz6L1SoM-jCpoiyAjBN9d.ttf",
      fontWeight: "600",
    },
    {
      src: "https://fonts.gstatic.com/s/notosans/v36/o-0mIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjcz6L1SoM-jCpoiyAaBN9d.ttf",
      fontWeight: "700",
    },
  ],
});

const PDFViewForReceipt = (props) => {
  const { receiptData } = props;

  // 595/2480 = 0.239 for 72 PPI so 16 = 16*0.239 = 3.82 = 4

  const styles = StyleSheet.create({
    document: { backgroundColor: "white" },
    page: {
      border: "1px solid #DAE0E2",
    },

    container: {
      height: 1000, //more than 841 will move to other page(A4)
      width: "100%",
    },
    topHeaderHr: {
      borderTop: "1px solid #dae0e2",
      borderBottom: "none",
      marginBottom: 0,
      marginTop: 0,
    },
  });

  const [receiptPdfData, setReceiptPdfData] = useState({});

  // Lifecycle Methods ===>

  useEffect(() => {
    if (receiptData?.payload_reciept) {
      let data = receiptData;
      data.payload_reciept = convertToBooleanHelper(data?.payload_reciept);

      data = getReceiptHeaderData(data);
      data = getReceiptFooterData(data);
      setReceiptPdfData({ ...data });
    }
  }, [receiptData]);

  // <===

  // Helper Methods ===>

  const getCustomMargins = (side, unit) => {
    return (+side).toString() + unit;
  };

  const getPdfPagePadding = () => {
    let paddingTop = "0",
      paddingRight = "0",
      paddingBottom = "0",
      paddingLeft = "0";
    let customMargins =
      receiptPdfData?.payload_reciept?.custom_margin_dimensions;
    if (receiptPdfData?.payload_reciept?.custom_margins_enabled) {
      paddingTop = getCustomMargins(
        customMargins?.rcptTop,
        customMargins?.unit
      );
      paddingBottom = getCustomMargins(
        customMargins?.rcptBottom,
        customMargins?.unit
      );
      paddingLeft = getCustomMargins(
        customMargins?.rcptLeft,
        customMargins?.unit
      );
      paddingRight = getCustomMargins(
        customMargins?.rcptRight,
        customMargins?.unit
      );
    }

    return `${paddingTop} ${paddingRight} ${paddingBottom} ${paddingLeft}`;
  };

  // <===
  return (
    <Document style={styles.document}>
      <Page
        size="A4"
        style={[
          styles.page,
          { padding: getPdfPagePadding(), fontFamily: "notosans" },
        ]}
      >
        <RaiseInvoicePdfHeaderView receiptPdfData={receiptPdfData} />
        <RaiseInvoicePdfMainContentView receiptPdfData={receiptPdfData} />
        <RaiseInvoicePdfFooterView receiptPdfData={receiptPdfData} />
      </Page>
    </Document>
  );
};

export default PDFViewForReceipt;
